import { Col, Form, Input, Row } from 'antd'
import ActionGroup from './ActionGroup'
import { useCallback, useEffect, useState } from 'react'

const FilterForm = ({
  setParams,
  loadingList,
  setLoadingList,
  params
}: {
  setParams: (input: any) => void
  setLoadingList: (input: any) => void
  loadingList: boolean
  params: any
}) => {
  const [form] = Form.useForm()
  const searchProduct= useCallback(() => {
    setLoadingList(true)
    form.validateFields().then(async (values) => {
      setParams((prev) => {        
        let paramsSearch: any = {
          page: 1,
          per_page: prev?.per_page,
        }

        if (values?.title) {
          paramsSearch = {
            ...paramsSearch,
            title: values?.title,
          }
        }
        return {
          ...paramsSearch,
        }
      })
    })
  }, [form, setParams])
useEffect(() => {
    form.setFieldValue('title', params?.title || '')
  }, [form, params?.title])
  return (
    <Form form={form} layout='vertical'>
      <Row gutter={[8, 0]} style={{ justifyContent: 'flex-end' }}>
       

        <Col span={24} md={{ span: 12 }} xl={{ span: 8 }}>
          <Form.Item name='title'>
            <Input placeholder='Tên sản phẩm' />
          </Form.Item>
        </Col>
        <Col span={24} md={{ span: 24 }} xl={{ span: 16 }}>
          <ActionGroup
            searchProduct={searchProduct}
            loadingList={loadingList}
          />
        </Col>
      </Row>
    </Form>
  )
}

export default FilterForm
